import { useEffect, useState } from "react";
import { ITaskIndex } from "../../../../../models/master/task";
import { connect, useDispatch } from "react-redux";
import { setTasks } from "../../../../../store/slices/master/taskSlice";
import {
  deleteTask,
  getTask,
  getTasks,
} from "../../../../../action/masters/taskActionCreator";
import LoaderSpinner from "../../../../../common-components/loader";
import { alertConstants, getAlertData } from "../../../../../helper/sweet-alert";
import ReactModal from "react-modal";
import TaskEdit from "../task/taskEdit";
import SweetAlert from "react-bootstrap-sweetalert";

const TaskViewAll = (props: ITaskIndex) => {
  const { tasks, getTasks, task, getTask, deleteTask } = props;
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [alertType, setAlertType] = useState<any>("success");
  const [dropdownState, setDropdownState] = useState<{
    [key: number]: boolean;
  }>({});
  const [showEdit, setShowEdit] = useState(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const dispatch = useDispatch();

  const getAllTasks = async () => {
    setIsLoading(true);
    try {
      await getTasks();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllTasks();
    return () => {
      dispatch(setTasks([]));
    };
  }, []);

  const onConfirm = async () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      try {
        setLoading(true);
        setShowAlert(false);
        setIsDelete(false);
        await deleteTask(itemToDelete, setAlert);
      } finally {
        setLoading(false);
      }
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllTasks();
    }
  };

  const getTaskStatusDisplayName = (status: number) => {
    switch (status) {
      case 1:
        return "Due";
      case 2:
        return "In Progress";
      case 3:
        return "Open";
      case 4:
        return "Hold";
      case 5:
        return "Completed";
      default:
        return "Unknown";
    }
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const isToggleButton = target.closest(".dropdown.dropstart a");
      const isToggleContent = target.closest(".dropdown-menu button");

      if (!isToggleButton && !isToggleContent) {
        setDropdownState({});
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const toggleDropdown = (id: number, e?: React.MouseEvent) => {
    e?.stopPropagation();
    setDropdownState((prevState) => {
      const newState = { ...prevState };
      Object.keys(newState).forEach((key) => {
        if (parseInt(key) !== id) {
          newState[parseInt(key)] = false;
        }
      });
      newState[id] = !newState[id];
      return newState;
    });
  };

  const editItem = (id: number) => {
    handleEditOpen();
    getTask(id);
  };

  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.deleteCheck);
    setItemToDelete(id);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  return (
    <div className="widgets">
      <div className="title">
        <h2>All Tasks</h2>
      </div>
      <div className="card-wrap">
        <div className="row">
          {isLoading ? (
            <LoaderSpinner />
          ) : tasks && tasks.length > 0 ? (
            tasks.map((task, index) => (
              <div className="col-lg-12 mb-3">
                <div className="btncard card h-100">
                  <div className="desc tasks-list tasks-list-dtls">
                    <li>
                      <div>
                        <h3 className="fw-bold">{task.name}</h3>
                        <p className="para-hide-2">{task.description}</p>
                      </div>
                      <div className="actions">
                        <span
                          className={
                            task.order === 1
                              ? "high"
                              : task.taskCurrentStatus === 2
                                ? "mid"
                                : "low"
                          }
                        >
                          {getTaskStatusDisplayName(task.order)}
                        </span>
                        <div className="dropdown dropstart">
                          <a
                            className="btn-more btn-task"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={() => toggleDropdown(task.id ?? 0)}
                          >
                            <img
                              src="/assets/images/icon/dots-more.svg"
                              alt=""
                              className="img-more"
                            />
                          </a>
                          {dropdownState[task.id ?? 0] && (
                            <ul className="dropdown-menu show">
                              <li>
                                <a
                                  className="dropdown-item"
                                  data-bs-toggle="modal"
                                  data-bs-target="#edittask"
                                  onClick={() => {
                                    editItem(task.id ?? 0);
                                    setDropdownState({});
                                  }}
                                >
                                  Edit
                                </a>
                              </li>
                              <li>
                                <a
                                  className="dropdown-item"
                                  type="button"
                                  onClick={() => {
                                    deleteItem(task.id ?? 0);
                                    setDropdownState({});
                                  }}
                                >
                                  Delete
                                </a>
                              </li>
                            </ul>
                          )}
                        </div>
                      </div>
                    </li>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No Records Found</p>
          )}
        </div>
      </div>
      <ReactModal
        isOpen={showEdit}
        onRequestClose={handleEditClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        style={{
          content: {
            outline: "none",
          },
        }}
      >
        <TaskEdit setShowEdit={handleEditClose} getAllTasks={getAllTasks} task={task} />
      </ReactModal>

      <SweetAlert
        show={showAlert}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      ></SweetAlert>
    </div>
  );
};

const mapDispatchToProps = {
  getTasks: () => getTasks(),
  getTask: (id: number) => getTask(id),
  deleteTask: (id: number, callBack: Function) => deleteTask(id, callBack),
};

function mapStateToProps(state: any) {
  return {
    tasks: state.task?.tasks,
    task: state.task?.task,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskViewAll);


